<template>
    <div class="goal-area ptb-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12" data-aos="fade-up" data-aos-duration="1200">
                    <div class="goal-image">
                        <img src="../../assets/images/goal3.png" alt="goal-image">
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="goal-content purple-color">
                        <span class="sub-title">Our Goal for Services</span>
                        <h2 class="nunito-font">Deal with customer queries in minutes</h2>
                        <ul class="overview-list">
                            <li data-aos="fade-up" data-aos-duration="1200">
                                <i class="flaticon-draw-check-mark"></i>
                                Recommender systems
                            </li>
                            <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                                <i class="flaticon-draw-check-mark"></i>
                                Omnichannel analytics
                            </li>
                            <li data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                                <i class="flaticon-draw-check-mark"></i>
                                Product line optimization
                            </li>
                        </ul>
                        <div class="btn-box" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
                            <router-link to="/contact" class="btn-style-one purple-color">
                                Get Started Now 
                                <i class="ph-caret-right"></i>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OurGoal'
}
</script>